import React from "react";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";
import { BASIS } from "@/lib/sk";

/**
 * Small provenance mark next to a fact: «Bekreftet», «Fra dokument» or «KI-forslag – må bekreftes».
 * Unconfirmed values get a one-click «Bekreft» that keeps the value and records who stood behind it.
 */
export function BasisMark({ basis, onConfirm, testId, className, compact = false, hideConfirmed = false }) {
  if (!basis) return null;
  const b = BASIS[basis] || BASIS.ki;
  const confirmed = basis === "bruker";
  if (confirmed && hideConfirmed) return <span className="sr-only" data-testid={testId} data-basis={basis}>Bekreftet</span>;
  return (
    <span className={cn("inline-flex items-center gap-1.5 text-[11px]", className)} data-testid={testId} data-basis={basis}>
      <span className={cn("inline-flex items-center gap-1", b.cls)} title={b.label}>{confirmed ? <Check className="h-3 w-3" strokeWidth={2.6} /> : <span className="inline-block h-1.5 w-1.5 rounded-full bg-current" />}{compact ? b.short : b.label}</span>
      {!confirmed && onConfirm ? <button type="button" onClick={onConfirm} className="rounded-full border border-black/[0.1] bg-white px-1.5 py-0 text-[10.5px] font-medium text-foreground/80 hover:border-black/[0.3] hover:text-foreground" data-testid={testId ? `${testId}-confirm` : undefined}>Bekreft</button> : null}
    </span>
  );
}
